import forEach from 'lodash/forEach';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useConfig } from '../../hooks';
import { useStores } from '../../stores';
import { sanitizeHTML } from '../../utilities';
import Button from '../Button';
import SelectSearch from '../SelectSearch';

const JsonSelect = ({ text, intentData }) => {
  const { t } = useTranslation();
  const { bot } = useStores();
  const { fontFamily, button, jobSearch } = useConfig();
  const [data, setData] = useState([]);
  const [value, setValue] = useState('');
  const [isDisabled, setDisabled] = useState(false);
  const [isReady, setReady] = useState(false);

  const renderData = responseData => {
    if (responseData.length) {
      const selectContent = [];
      forEach(responseData, item => {
        const dataValue = Object.values(item);
        selectContent.push({
          value: dataValue[0],
          label: dataValue[0]
        });
        return selectContent;
      });
      return selectContent;
    }
    return [];
  };

  const onSubmit = () => {
    const requestParameters = {
      [intentData.inputName]: value.value
    };

    if (jobSearch && jobSearch.enabled) {
      bot.formFields[intentData.inputName] = value || bot.formFields[intentData.inputName];
    }
    bot.processSendForm(requestParameters, intentData.mesId, t('submitButton'));
    setValue('');
    setDisabled(true);
  };

  useEffect(() => {
    if (!data.length) {
      bot.jsonFile(intentData.url, intentData.inputName).then(response => {
        const changedData = renderData(response);

        bot.jsonSelectList[intentData.inputName] = changedData;
        setData(changedData);
        setReady(true);
      });
    }
  }, [bot, data.length, intentData.inputName, intentData.url]);

  return (
    <Root>
      {text && (
        <Text>
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(text)
            }}
          />
        </Text>
      )}
      <SelectWrapper>
        {!isReady ? (
          <LoaderWrapper>Loading ... </LoaderWrapper>
        ) : (
          <Select options={data} setValue={setValue} isDisabled={isDisabled} />
        )}
        <ButtonSubmit
          type="button"
          textFontFamily={fontFamily}
          color={button.hoverColor}
          hoverColor={button.color}
          backgroundColor={button.color}
          borderRadius={button.borderRadius}
          onClick={onSubmit}
          disabled={!value || isDisabled}
        >
          {t('submitButton')}
        </ButtonSubmit>
      </SelectWrapper>
    </Root>
  );
};

JsonSelect.propTypes = {
  text: PropTypes.string,
  intentData: PropTypes.shape({
    url: PropTypes.string,
    intent: PropTypes.number,
    inputName: PropTypes.string,
    mesId: PropTypes.number
  }).isRequired
};

const Root = styled.div``;

const Text = styled.p`
  margin-bottom: 6px !important;
`;

const SelectWrapper = styled.div``;

const Select = styled(props => <SelectSearch {...props} />)`
  margin-bottom: 8px;
`;

const LoaderWrapper = styled.div`
  padding: 10px 8px;
  margin-bottom: 8px;
`;

const ButtonSubmit = styled(Button)`
  background-color: ${props => props.backgroundColor};
  border: 1px solid ${props => props.backgroundColor};
`;

export default JsonSelect;
